import { ref, computed } from 'vue';

// Global state created once
const pageTitle = ref('');
const pageContext = ref('');
const isSidebarOpen = ref(false);


export function useAiContext() {
  const enableAiChat = computed(() => {
    try {
      const browserStorage = window.localStorage['readyChek'];
      if (!browserStorage) return false;
      const rcStorage = JSON.parse(browserStorage);
      return rcStorage['ai'] ? rcStorage['ai'] : false;
    } catch (e) {
      return false;
    }
  });
  
  const setAiContext = (title, context) => {
    pageTitle.value = title;
    pageContext.value = context.value;
  };
  
  const setSidebarOpen = (isOpen) => {
    isSidebarOpen.value = isOpen;
  };

  return {
    pageTitle,
    pageContext,
    setAiContext,
    isSidebarOpen,
    setSidebarOpen,
    enableAiChat
  };
}
